import React from 'react'
import Box from '@mui/joy/Box'
import Checkbox, { type CheckboxProps } from '@mui/joy/Checkbox'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'
import type { FiltersType } from '../types'

export default function GarageRestrictionsToggle({
    currentFilters,
    handleChecked,
}:{
    currentFilters: FiltersType,
    handleChecked: CheckboxProps['onChange'],
}) {
  
    const { t } = useTranslation()

    return (
        <Box>
            <Typography level='title-md'>{t('filters.restrictions')}</Typography>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5,
                mt: 1.5,
            }}>
                <Checkbox
                    label={t('filters.electricAllowed')}
                    variant="outlined"
                    checked={currentFilters.electricAllowed}
                    name="electricAllowed"
                    onChange={handleChecked}
                />
                <Checkbox
                    label={t('filters.lpgCngAllowed')}
                    variant="outlined"
                    checked={currentFilters.lpgCngAllowed}
                    name="lpgCngAllowed"
                    onChange={handleChecked}
                />
                <Checkbox
                    label={t('filters.motorbikesAllowed')}
                    variant="outlined"
                    checked={currentFilters.motorbikesAllowed}
                    name="motorbikesAllowed"
                    onChange={handleChecked}
                />
            </Box>
        </Box>
    )
}
